import React, {useEffect, useState} from "react";
import useIsMounted from "../../../../../../hooks/use-is-mounted";
import {Col, Row} from "reactstrap";
import {ArrowBack} from "@mui/icons-material";
import Api from "../../../../../../../core/services/api/api";
import IconButton from "../../../../../../components/base/button/icon_button";
import {Paper} from "@mui/material";
import {Switch} from "../../../../../../components/base/switch";
import {useConfigureNotebook} from "../../../../../../hooks/use-notebook-config";
import {useHistory, useParams} from "react-router-dom";
import useBehavioralAnalyticsTool from "../../../../../../hooks/use-behavioural-analytics-tool";


// TODO: This page is deprecated and should be removed.


/**
 * Groups all the access levels based on their name, and determines if they are selected based on the
 * selected Group's access level list.
 *
 * Returns a list of each access record
 *
 * @param accessLevels {[]}
 * @param selectedGroup {any}
 * @return {[]|*[]}
 */
const createGroups = (accessLevels, selectedGroup) => {
    const selectedTokens = selectedGroup?.accessLevels?.map(e => e.token);
    if (!accessLevels) return [];
    const accessLevelsWithSelected = accessLevels.map(accessLevel => {
        return {
            ...accessLevel,
            partName: accessLevel.partName
                    ?.trim()
                    ?.replaceAll(/ +\S/g, (chars) => chars.trim().toUpperCase())
                    ?.replaceAll(/[A-Z]+/g, (chars) => ` ${chars}`)
                ?? '',
            selected: selectedTokens.includes(accessLevel.token)
        }

    })
    const accessGroups = {};
    for (let index = 0; index < accessLevelsWithSelected.length; ++index) {
        if (accessGroups[accessLevelsWithSelected[index].controllerName]) {
            accessGroups[accessLevelsWithSelected[index].controllerName].push(accessLevelsWithSelected[index]);
        } else {
            accessGroups[accessLevelsWithSelected[index].controllerName] = [accessLevelsWithSelected[index]];
        }
    }
    const list = [];
    for (let [key, value] of Object.entries(accessGroups)) {
        list.push({
            name: key
                ?.trim()
                ?.replaceAll(/ +\S/g, (chars) => chars.trim().toUpperCase())
                ?.replaceAll(/[A-Z]+/g, (chars) => ` ${chars}`),
            accessLevels: value,
            loading: false,
        })
    }
    return list;
}


const OperatorGroupAccessLevels = () => {
    const history = useHistory()
    const params = useParams()
    const [loading, setLoading] = useState(true);
    const [groups, setGroups] = useState();
    const [operatorGroup, setOperatorGroup] = useState();
    const isMounted = useIsMounted();
    const {configureNotebookTags} = useConfigureNotebook('operator-group-access-levels-view');
    const {configureBehavioralTool} = useBehavioralAnalyticsTool();

    /**
     * As soon as the component is mounted:
     * - Configures the notebook tags for the view
     * - Configures the behavioral analytics tool for the view
     */
    useEffect(() => {
        configureNotebookTags((noteTags) => noteTags.operatorsGroupAccessLevels(params.groupId));
        configureBehavioralTool((tags) => tags.operatorsGroupAccessLevels(params.groupId));
    }, [configureBehavioralTool, configureNotebookTags, params.groupId]);

    /**
     * Gets all the available access levels and the selected groups full information including their access levels as
     * soon as the component mounts
     */
    useEffect(() => {
        getAccessLevelsAndGroup()
    }, [])

    /**
     * Gets all the available access levels to be assigned to different groups from the server. If the component is
     * mounted, and the result of the api call is successful, then Fetches the record's current access levels from
     * the server and sends the results through createGroup()
     */
    const getAccessLevelsAndGroup = () => {
        setLoading(true);
        Api.getAllAccessLevels().then((response) => {
            if (!isMounted()) return;
            Api.getOperatorGroupAccessLevels(params.groupId).then((res) => {
                if (!isMounted()) return;
                setGroups(createGroups(response?.data ?? [], res?.data))
                setOperatorGroup(res?.data);
                setLoading(false);
            })
        })
    }


    /**
     * Calls api for adding access levels for a specific operator record.
     *
     * If access level => only adds that access level for operator otherwise adds all the access levels of the record
     * to the operator record.
     *
     * @param accessGroup {any}
     * @param accessLevel {any}
     */
    const addAccessLevelsToOperatorGroup = (accessGroup, accessLevel = null) => {
        setEntityLoading(accessGroup, accessLevel, true);
        const forApi = {
            id: params.groupId,
            accessLevels: accessLevel
                ? [{name: accessGroup.name, token: accessLevel.token}]
                : accessGroup.accessLevels.map(e => ({name: accessGroup.name, token: e.token}))
        }
        Api.addAccessLevelsForOperatorGroup(forApi).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                setGroups(prevState => {
                    const forApiTokens = forApi.accessLevels?.map(e => e.token);
                    return prevState.map(g => g.name === accessGroup.name
                        ? {
                            ...g,
                            accessLevels: g.accessLevels.map(a => forApiTokens.includes(a.token)
                                ? {...a, selected: true}
                                : a)
                        }
                        : g)
                });
            }
            setEntityLoading(accessGroup, accessLevel, false);
        })
    }


    /**
     * Calls api for removing access levels for a specific operator record.
     *
     * If access level => only removes that access level from operator otherwise removes all the access levels of the
     * record from the operator record.
     *
     * @param accessGroup {any}
     * @param accessLevel {any}
     */
    const removeAccessLevelsFromOperatorGroup = (accessGroup, accessLevel = null) => {
        setEntityLoading(accessGroup, accessLevel, true);
        const forApi = {
            id: params.groupId,
            accessLevels: accessLevel
                ? [{name: accessGroup.name, token: accessLevel.token}]
                : accessGroup.accessLevels.map(e => ({name: accessGroup.name, token: e.token}))
        }
        Api.removeAccessLevelFromOperatorGroup(forApi).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                setGroups(prevState => {
                    const forApiTokens = forApi.accessLevels?.map(e => e.token);
                    return prevState.map(g => g.name === accessGroup.name
                        ? {
                            ...g,
                            accessLevels: g.accessLevels.map(a => forApiTokens.includes(a.token)
                                ? {...a, selected: false}
                                : a)
                        }
                        : g)
                });
            }
            setEntityLoading(accessGroup, accessLevel, false);
        })
    }

    /**
     * Sets the loading state of the access record or the access level in a record to the value.
     *
     * if access level => sets the state of that access level to loading,
     * otherwise set he state of the record to loading'
     *
     * @param accessGroup {any}
     * @param accessLevel {any}
     * @param val {boolean} the new value for the loading state
     */
    const setEntityLoading = (accessGroup, accessLevel, val) => {
        if (accessLevel) {
            setGroups(prevState => prevState.map(g => g.name === accessGroup.name
                ? {
                    ...g,
                    accessLevels: g.accessLevels.map(a => a.token === accessLevel.token
                        ? {...a, loading: val}
                        : a)
                }
                : g));
        } else {
            setGroups(prevState => prevState.map(g => g.name === accessGroup.name
                ? {
                    ...g,
                    loading: val,
                }
                : g));
        }
    }


    /**
     * Toggles the access levels of a record for the selected record. First sets the access level state to loading, then
     * calls the
     * api and then if the result is correct, then change the selected value of all the access levels of the record.
     *
     * @param accessGroup {any} the record in which the access level belongs to
     * @param val {boolean} the identifier to add or remove the access level
     */
    const onAccessGroupToggle = (accessGroup, val) => {
        if (val) {
            addAccessLevelsToOperatorGroup(accessGroup)
        } else {
            removeAccessLevelsFromOperatorGroup(accessGroup)
        }
    }


    /**
     * Toggles the access level for the selected record. First sets the access level state to loading, then calls the
     * api and then if the result is correct, then change the selected value of the access level.
     *
     * @param accessGroup {any} the record in which the access level belongs to
     * @param accessLevel {any} the access level to be toggled
     * @param val {boolean} the identifier to add or remove the access level
     */
    const onAccessLevelToggle = (accessGroup, accessLevel, val) => {
        if (val) {
            addAccessLevelsToOperatorGroup(accessGroup, accessLevel)
        } else {
            removeAccessLevelsFromOperatorGroup(accessGroup, accessLevel)
        }
    }

    return (
        <>
            <Row className='no-gutters w-100 justify-content-start align-items-center my-4'>
                <IconButton
                    onPressed={() => history.goBack()}
                    color={'secondary'}
                >
                    <ArrowBack className={'icon normal'}/>
                </IconButton>
                <p className='ml-3 text-lg font-weight-semi-bold text-color-1'>{`Access Levels of ${operatorGroup?.name ?? ''}`}</p>
            </Row>
            <Row className='no-gutters w-100 justify-content-center align-items-start my-4'>
                {
                    loading
                        ? (
                            <Row className='loading access-level w-100 no-gutters'>
                                <Col xs={12} className='pb-3'>
                                    <div/>
                                </Col>
                                <Col xs={12} className='py-3'>
                                    <div/>
                                </Col>
                                <Col xs={12} className='pb-3'>
                                    <div/>
                                </Col>
                            </Row>
                        )

                        : groups?.map((group) => (
                            <AccessGroup
                                key={group.name}
                                group={group}
                                onToggleAll={onAccessGroupToggle}
                                onToggle={onAccessLevelToggle}
                            />
                        ))
                }
            </Row>
        </>
    );
}

const AccessGroup = ({group, onToggle, onToggleAll}) => {
    return (
        <Paper className={`paper w-100 my-3`}>
            <Row className='no-gutters align-items-center justify-content-between w-100 py-3 px-4'>
                <Col xs={12} className='row no-gutters justify-content-start align-items-center mb-4 mt-3'>
                    <Switch
                        color={'primary'}
                        checked={!group.accessLevels.map(e => e.selected).includes(false)}
                        disabled={group.loading}
                        onChange={(val) => onToggleAll(group, val)}
                    />
                    <p className='text-md text-color-1 ml-3'>{group.name}</p>
                </Col>
                <div className='divider w-100'/>
                <Col xs={12} className='row no-gutters justify-content-start align-items-center my-4 flex-wrap'>
                    {
                        group.accessLevels?.map(accessLevel => (
                            <Col xs={12} md={6} xl={4}
                                 key={`${accessLevel.token}-${accessLevel.id}`}
                                 className='no-gutters d-flex flex-column align-items-center justify-content-start h-100 pb-4'>
                                <Switch
                                    color={'secondary'}
                                    checked={accessLevel.selected}
                                    disabled={group.loading || accessLevel.loading}
                                    onChange={(val) => onToggle(group, accessLevel, val)}
                                />
                                <p className='text-sm text-color-1 mt-2'>
                                    {accessLevel.partName}
                                </p>
                            </Col>
                        ))
                    }
                </Col>
            </Row>
        </Paper>

    );
}


export default OperatorGroupAccessLevels;
